import { BrowserModule } from '@angular/platform-browser';
import { Component } from '@angular/core';

@Component({
    selector: 'menu',
    templateUrl: './menu.component.html'
})

export class MenuComponent {}



// WEBPACK FOOTER //
// /home/xpro/Documentos/ances/myjangular/src/app/layout/menu/menu.component.ts